import { render } from "./addStaffComponent.vue?vue&type=template&id=7fd98750"
import script from "./addStaffComponent.vue?vue&type=script&lang=js"
export * from "./addStaffComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__